import { useEffect } from 'react';
import { HEADER_ID, HEADER_LINE_ID } from 'src/client/components/constants';

export const useSidebarHeight = () => {
  useEffect(() => {
    const updateHeight = () => {
      const headerHeight =
        document.getElementById(HEADER_ID)?.getBoundingClientRect().height || 0;
      const searchBarHeight =
        document.getElementById(HEADER_LINE_ID)?.getBoundingClientRect()
          .height || 0;

      document.documentElement.style.setProperty(
        '--sidebar-height',
        `${window.innerHeight - headerHeight - searchBarHeight}px`,
      );
    };

    window.addEventListener('resize', updateHeight);
    updateHeight();

    return () => window.removeEventListener('resize', updateHeight);
  }, []);
};
